import { NavigateFunction } from "react-router";
import { Layout } from "../types/GlobalInterfaces";
import { AppConfirm } from "./PopupUtil";

export const handleSaveGlobalLayout = async ({
  layout,
  navigate,
  tenantID,
  onSave,
}: {
  layout: Layout;
  navigate: NavigateFunction;
  tenantID: string;
  onSave: () => void;
}) => {
  const isGlobalLayout = !!layout?.GlobalID;
  let data: any = {
    title: "Manage Cloud Layouts?",
    html: `
          <div class="font-weight-500 mb-2">You can't unset a global layout here.</div>
          To manage global layouts, visit the layouts creates settings by clicking the button below.
        `,
    icon: "warning",
    confirmButtonColor: "var(--primary)",
    confirmButtonText: "Go to settings",
  };

  if (!isGlobalLayout) {
    data.title = "Confirm";
    data.html = `
          <div class="font-weight-500 mb-2">Are you sure you want to make this Layout Global?</div>
        `;
    data.confirmButtonText = "Yes";
    data.showLoaderOnConfirm = true;
  }

  return AppConfirm({
    ...data,
  }).then((res) => {
    if (!res.isConfirmed) return;

    isGlobalLayout
      ? navigate(`/clouds/${tenantID}/settings/globals/Layouts`)
      : onSave();
  });
};
